<div class="why-choose-us">
  <h2 class="title">{{ 'whyChooseUs.title' | translate }}</h2>

  <div class="content">
    <!-- left column -->
    <div class="col left">
      <div class="info-card">
        <h3>{{ 'whyChooseUs.linkedinVisibility.title' | translate }}</h3>
        <p>{{ 'whyChooseUs.linkedinVisibility.description' | translate }}</p>
      </div>

      <div class="info-card mt-3 pt-5">
        <h3>{{ 'whyChooseUs.careerCoaching.title' | translate }}</h3>
        <p>{{ 'whyChooseUs.careerCoaching.description' | translate }}</p>
      </div>
    </div>

    <!-- center with arc and robot -->
    <div class="center">
      <div class="shield mt-4">
        <div class="shield-bg"></div>
        <img class="robot" src="../../../../../assets/img/Image 2.png" alt="robot"/>
      </div>
    </div>

    <!-- right column -->
    <div class="col right">
      <div class="info-card">
        <h3>{{ 'whyChooseUs.atsFriendly.title' | translate }}</h3>
        <p>{{ 'whyChooseUs.atsFriendly.description' | translate }}</p>
      </div>

      <div class="info-card mt-3 pt-3">
        <h3>{{ 'whyChooseUs.coverLetters.title' | translate }}</h3>
        <p>{{ 'whyChooseUs.coverLetters.description' | translate }}</p>
      </div>
    </div>
  </div>
</div>